import React from "react";

import { CustomFieldsManageDialog } from "#app/components/custom-fields/custom-fields-manage-dialog";

type CustomFieldsDialogActions = {
  openDialog: () => void;
  closeDialog: () => void;
};

// ---------------------------------------------------------------------------
// Global emitter — lets callers inside bottom-sheet portals (which break
// React context) still open/close the dialog.
// ---------------------------------------------------------------------------
type Listener = (open: boolean) => void;
const listeners = new Set<Listener>();
function emit(open: boolean) {
  listeners.forEach((l) => l(open));
}

/** Get stable open/close callbacks. Works inside bottom-sheet portals. */
export function useCustomFieldsDialogActions(): CustomFieldsDialogActions {
  return React.useMemo<CustomFieldsDialogActions>(
    () => ({
      openDialog: () => emit(true),
      closeDialog: () => emit(false),
    }),
    [],
  );
}


export function CustomFieldsDialog() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    listeners.add(setOpen);
    return () => {
      listeners.delete(setOpen);
    };
  }, []);

  return <CustomFieldsManageDialog open={open} onClose={() => setOpen(false)} />;
}
